<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
useSeoMeta({
  title: "Carta Fedeltà Prénatal Lover - Area Clienti",
  ogTitle: "Carta Fedeltà Prénatal Lover - Area Clienti",
  ogDescription: "Scopri il programma fedeltà di Prénatal, registrati e gestisci qui la tua card con tutti i tuoi vantaggi",
  ogImage:
    "https://media.prenatal-it.prenatal-services.com/2025/05/3319e154-og-image.png",
  ogImageWidth: "200",
  ogImageHeight: "200",
  ogType: "website",
  ogUrl: "https://card.prenatal.com/",
  ogSiteName: "Loyalty",
  articlePublisher: "https://www.facebook.com/prenatalitalia",
  twitterCard: "summary_large_image",
  twitterSite: "@Prenatal_it",
});

useHead({
  meta: [
    {
      name: "google-site-verification",
      content: "-5kxfSUkCRJBomlZc5VeDyOVXoD4ysp6Gln0Rgyqnxo",
    },
    { property: "og:locale", content: "it_IT" },
    { property: "og:image:type", content: "image/png" },
  ],
  script: [
    {
      children:
        '(function () { if (window.self !== window.top) return; (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" }); var f = d.getElementsByTagName(s)[0],j = d.createElement(s),dl = l != "dataLayer" ? "&l=" + l : "";j.async = true;j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;f.parentNode.insertBefore(j, f);})(window, document, "script", "dataLayer", "GTM-PBSPR2NS"); })();',
    },
  ],
  noscript: [
    {
      children:
        '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PBSPR2NS" height="0" width="0" style="display: none; visibility: hidden"> </iframe>',
      body: true,
    },
  ],
});

useHead({
  script: [
    {
      children:
        '(function () { if (window.self !== window.top) { window.parent.postMessage({ source: "prenatal-card-iframe", height: document.body.scrollHeight }, "*"); } })();',
      body: true,
    },
  ],
});
</script>
